var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("g", { attrs: { display: "none" } }, [
      _c("path", {
        attrs: {
          display: "inline",
          stroke: "#000000",
          "stroke-width": "0.2205",
          d:
            "M97.828,90.124c0,5.176-4.199,9.375-9.377,9.375   H7.199c-5.176,0-9.375-4.199-9.375-9.375V8.874c0-5.18,4.199-9.375,9.375-9.375h81.252c5.178,0,9.377,4.195,9.377,9.375V90.124z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", [
      _c("path", {
        attrs: {
          d:
            "M86.55,69.322c0,2.602-0.986,4.818-2.955,6.658c-1.969,1.842-4.332,2.76-7.102,2.76c-2.773,0-5.133-0.918-7.092-2.76   c-1.955-1.84-2.934-4.057-2.934-6.658c0-2.984,1.24-5.416,3.713-7.301V33.478c0-1.732,0.623-3.209,1.869-4.424   c1.248-1.219,2.752-1.826,4.504-1.826c1.736,0,3.217,0.615,4.443,1.838c1.225,1.232,1.84,2.711,1.84,4.445v28.51   C85.314,63.906,86.55,66.337,86.55,69.322z M81.626,69.001c0-1.518-0.629-2.768-1.898-3.738V33.349   c0-0.885-0.311-1.646-0.934-2.281c-0.625-0.633-1.383-0.953-2.27-0.953c-0.893,0-1.654,0.316-2.301,0.938   c-0.646,0.623-0.965,1.377-0.965,2.268v31.943c-1.27,0.947-1.902,2.197-1.902,3.738c0,1.338,0.498,2.463,1.498,3.396   c1.008,0.93,2.219,1.398,3.639,1.398c1.412,0,2.627-0.469,3.631-1.398C81.123,71.464,81.626,70.339,81.626,69.001z M78.777,51.328   v14.98c0.969,0.738,1.459,1.641,1.459,2.693c0,0.973-0.361,1.807-1.098,2.49c-0.729,0.688-1.611,1.035-2.645,1.035   c-1.037,0-1.92-0.348-2.648-1.035c-0.732-0.684-1.098-1.518-1.098-2.49c0-1.053,0.5-1.955,1.494-2.693v-14.98H78.777z"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M64.152,51.509h-6.951l4.17-7.203h-3.584l-4.186,7.203h-4.689l4.189-7.145H44.14l2.592-4.498l10.469,0.014l-1.791-3.105   l-6.902,0.018l3.574-6.191l-2.701-1.557L45.91,35.06l-4.16-7.215l-1.791,3.105l4.146,7.229l-2.398,4.15l-4.314-7.303l-4.5,7.588   l-2.455-4.25l5.246-9.062h-3.584l-3.457,5.945l-3.553-6.152l-2.705,1.562l3.471,6.016l-8.32-0.008l1.791,3.104l8.309-0.01   l2.648,4.578l-8.652,0.004l1.297,2.254l2.807,4.914h-4.822l-4.191-7.203h-3.582l4.168,7.203h-6.945v3.119h7.102l-3.424,5.975   l1.795,3.098l5.229-9.072h4.836l-4.186,7.369l8.646-0.016l-2.627,4.549l-8.303-0.018l-1.791,3.102l8.32-0.006l-3.471,6.014   l2.703,1.562l3.549-6.15l3.459,5.943h3.582l-5.244-9.059l2.346-4.062l4.414,7.641L41.634,64l2.367,4.102l-4.143,7.23l1.791,3.105   l4.156-7.211l3.471,6.016l2.709-1.561L48.412,69.5l6.898,0.012l1.793-3.104l-10.469,0.006l-2.555-4.416h9.113l-4.35-7.369h4.607   l5.229,9.072l1.791-3.098l-3.424-5.975h7.105V51.509z M47.843,47.382l-2.424,4.127h-5.404l2.381-4.127H47.843z M37.388,40.943   l2.592,4.385l-2.766,4.777l-2.596-4.494L37.388,40.943z M26.828,47.355h5.193l2.398,4.154h-5.215L26.828,47.355z M26.902,58.972   l2.467-4.344h5.236l-2.502,4.342L26.902,58.972z M37.296,65.474l-2.674-4.631l2.592-4.492l2.68,4.639L37.296,65.474z M47.908,58.98   h-5.568l-2.506-4.352h5.504L47.908,58.98z"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81f1d8fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f1d8fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/IconCold.vue
// module id = null
// module chunks = 